import React, { createContext, useContext, ReactNode } from 'react';
import { useServerDropReviews } from '../hooks/UseServerDropReviews';

/** useInlinePriceEdit 를 서버 검토(감사 #566)로 감싼 값 — 그 훅의 것 전부 + serverReview. */
type CardEditValue = ReturnType<typeof useServerDropReviews>;

const CardEditContext = createContext<CardEditValue | null>(null);

/**
 * CardPageContext 에서 edit 상태만 떼어낸 별도 컨텍스트(2026-08-13) — editingId 가
 * 바뀔 때마다(가격 수정 시작/종료) CardPageContext 전체 구독자가 리렌더되는 걸 막기
 * 위해 분리했다. value 는 CardPageProvider 가 useCardData() 로 만든 edit 객체를
 * 그대로 넘겨준다(여기서 새로 만들지 않음 — jobs 훅이 같은 edit 인스턴스의
 * reconcilePendingDrops 를 참조해야 하므로 인스턴스는 하나여야 한다).
 */
export function CardEditProvider({ value, children }: { value: CardEditValue; children: ReactNode }) {
  return (
    <CardEditContext.Provider value={value}>
      {children}
    </CardEditContext.Provider>
  );
}

export function useCardEdit(): CardEditValue {
  const ctx = useContext(CardEditContext);
  if (!ctx) throw new Error('useCardEdit must be used within CardEditProvider');
  return ctx;
}